import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import {SplitText} from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

export default class ProcessHero {
    constructor() {
        this.element = document.querySelector('.process__hero');
        this.textElement = this.element.querySelector('[data-split-text]');
        this.chars = [];

        this.init();
    }

    init() {
        if (!this.textElement) return;

        this.animateChars();
    }

    animateChars() {
        const split = new SplitText(this.textElement, { type: "chars, words",  wordsClass: "word", charsClass: "char" });

        // État initial : tous les caractères sont invisibles
        gsap.set(split.chars, {
            opacity: 0.2,
        });

        // Animation au scroll : chaque lettre apparaît progressivement
        gsap.to(split.chars, {
            opacity: 1,
            duration: 0.1,
            y: 0,
            stagger: {
                each: 0.02,
                from: 'start'
            },
            ease: 'power2.out',
            scrollTrigger: {
                trigger: this.element,
                start: 'top 80%',
                end: 'top 45%',
                scrub: 1
            }
        });
    }

    destroy() {
        // Kill tous les ScrollTriggers liés à cet élément
        ScrollTrigger.getAll().forEach(trigger => {
            if (trigger.vars.trigger === this.element) {
                trigger.kill();
            }
        });

        // Restaure le texte original si nécessaire
        if (this.textElement && this.chars.length) {
            const originalText = this.chars.map(char =>
                char.classList.contains('process__title-char--space') ? ' ' : char.textContent
            ).join('');

            this.textElement.textContent = originalText;
        }

        this.chars = [];
    }
}